import React from "react";
import ResourceDetailLightBox2 from "components/resource/ResourceDetailLightBox2";
import DBResourceDetailComp2 from "components/resource/DBResourceDetailComp2";

@ResourceDetailLightBox2
class DBResourceDetailLightBox2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let { t } = this.props;
    return (
      <>
        <h3 className="secHead">{t("jumperrwd.common.bookDetail")}</h3>
        <DBResourceDetailComp2 {...this.props} isLightBox={true} />
      </>
    );
  }
}

export default DBResourceDetailLightBox2;
